<section>
  <div class="w-full">
    <p-table
      #dt
      dataKey="id"
      [value]="trips"
      [(selection)]="selectedItems"
      (selectionChange)="onSelectionChange()"
      (sortFunction)="customSort($event)"
      [customSort]="true"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [paginator]="true"
      [rows]="rows"
      [first]="first"
      [scrollable]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="onPageChange($event)"
      [rowsPerPageOptions]="[5, 10, 25, 50]"
      paginatorDropdownAppendTo="body"
      class="!text-sm"
      [globalFilterFields]="[
        'title',
        'fileName',
        'createdAt',
        'countryName',
        'clientName',
        'days',
        'travellers',
        'totalImpact',
        'ecoScore',
      ]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>
            <div
              class="flex flex-row items-center justify-start gap-1 !text-gray-500"
            >
              <p-tableHeaderCheckbox />
            </div>
          </th>
          <th pSortableColumn="title">
            <div
              class="flex flex-row items-center justify-start gap-1 !text-gray-500"
            >
              {{ "travelBoards.trips" | transloco }}
              <p-sortIcon field="title" />
            </div>
          </th>
          @if (tableSettingService.isColumnVisible("fileName")) {
            <th pSortableColumn="fileName">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.fileName" | transloco }}
                <p-sortIcon field="fileName" />
              </div>
            </th>
          }
          @if (tableSettingService.isColumnVisible("createdAt")) {
            <th pSortableColumn="createdAt">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.createdAt" | transloco }}
                <p-sortIcon field="createdAt" />
              </div>
            </th>
          }
          @if (tableSettingService.isColumnVisible("countryName")) {
            <th pSortableColumn="countryName" class="!max-w-[150px]">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.country" | transloco }}
                <p-sortIcon field="countryName" />
              </div>
            </th>
          }
          @if (
            tableSettingService.isColumnVisible("companyClients") &&
            packLimitationService.canFilterClient()
          ) {
            <th pSortableColumn="companyClients">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.client" | transloco }}

                <p-columnFilter
                  field="companyClients"
                  matchMode="in"
                  display="menu"
                  [showMatchModes]="false"
                  [showOperator]="false"
                  [showAddButton]="false"
                  [showApplyButton]="false"
                  [showClearButton]="false"
                >
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-multiselect
                      [(ngModel)]="clientNameFilterValue"
                      [options]="clientNameFilterOptions()"
                      [placeholder]="'travelBoards.client' | transloco"
                      (onChange)="filterByClient()"
                      [ngStyle]="{ 'min-width': '12rem' }"
                      [panelStyle]="{ minWidth: '16rem' }"
                      appendTo="body"
                    >
                      <ng-template let-option #item>
                        <div class="flex items-center gap-2">
                          <app-client-avatar [clientName]="option" />
                          <span>{{ option }}</span>
                        </div>
                      </ng-template>
                    </p-multiselect>
                  </ng-template>
                </p-columnFilter>

                <p-sortIcon field="companyClients" />
              </div>

              <div class="flex items-center"></div>
            </th>
          }

          @if (tableSettingService.isColumnVisible("days")) {
            <th pSortableColumn="days">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.days" | transloco }}
                <p-sortIcon field="days" />
              </div>
            </th>
          }
          @if (tableSettingService.isColumnVisible("travellers")) {
            <th pSortableColumn="travellers">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.travellers" | transloco }}
                <p-sortIcon field="travellers" />
              </div>
            </th>
          }
          @if (tableSettingService.isColumnVisible("totalImpact")) {
            <th pSortableColumn="totalImpact">
              <div
                class="flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.emissionsShort" | transloco }}
                <p-sortIcon field="totalImpact" />
              </div>
            </th>
          }
          @if (tableSettingService.isColumnVisible("ecoScore")) {
            <th pSortableColumn="ecoScore">
              <div
                class="no-wrap flex flex-row items-center justify-start gap-1 !text-gray-500"
              >
                {{ "travelBoards.ecoScore" | transloco }}
                <p-sortIcon field="ecoScore" />
              </div>
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-trip>
        <tr
          class="group cursor-pointer !text-base transition-colors hover:bg-greyscale-50"
          (click)="
            trip.id
              ? trip.isDraft
                ? travelBoardService.editTrip(trip.id)
                : travelBoardService.viewTrip(trip.id)
              : null
          "
        >
          <td (click)="$event.stopPropagation()">
            <p-tableCheckbox [value]="trip" />
          </td>
          <td class="!min-w-[250px] !max-w-[300px]">
            <div class="flex items-center justify-between gap-2">
              <div class="flex min-w-0 flex-col">
                <span
                  class="truncate text-primary-500"
                  [pTooltip]="trip.title"
                  tooltipPosition="top"
                  [tooltipOptions]="{ showDelay: 500 }"
                >
                  {{ trip.title }}
                </span>
              </div>

              <div class="flex shrink-0 items-center gap-2">
                @if (trip.needsVerification) {
                  <span
                    class="inline-flex shrink-0 items-center justify-center rounded bg-amber-100 p-1 text-amber-700"
                    [pTooltip]="'travelBoards.needsVerificationTooltip' | transloco"
                    tooltipPosition="top"
                  >
                    <lucide-icon name="sparkles" class="h-4 w-4" />
                  </span>
                }
                @if (trip.hasValidationErrors) {
                  <span
                    class="inline-flex shrink-0 items-center justify-center rounded bg-red-100 p-1 text-red-700"
                    [pTooltip]="'travelBoards.validationErrors' | transloco"
                    tooltipPosition="top"
                  >
                    <lucide-icon name="triangle-alert" class="h-4 w-4" />
                  </span>
                }
                @if (trip.isDraft) {
                  <span
                    class="inline-flex shrink-0 items-center rounded bg-primary-100 px-2 py-1 text-xs font-semibold uppercase text-primary-700"
                  >
                    {{ "travelBoards.draft" | transloco }}
                  </span>
                }
              </div>
            </div>
          </td>
          @if (tableSettingService.isColumnVisible("fileName")) {
            <td class="!max-w-[200px]">
              @if (trip.fileName) {
                <span
                  class="block truncate text-greyscale-600"
                  [pTooltip]="trip.fileName"
                  tooltipPosition="top"
                  [tooltipOptions]="{ showDelay: 500 }"
                >
                  {{ trip.fileName }}
                </span>
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (tableSettingService.isColumnVisible("createdAt")) {
            <td>
              @if (trip.createdAt) {
                {{ trip.createdAt | date: "dd/MM/yyyy" }}
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (tableSettingService.isColumnVisible("countryName")) {
            <td class="!max-w-[150px] truncate">
              @if (trip.countryName) {
                {{ trip.countryName }}
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (
            tableSettingService.isColumnVisible("companyClients") &&
            packLimitationService.canFilterClient()
          ) {
            <td>
              @if (trip.companyClients && trip.companyClients.length > 0) {
                <div class="flex flex-1 flex-row gap-1">
                  @for (client of trip.companyClients; track $index) {
                    <app-client-avatar [clientName]="client" />
                  }
                </div>
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (tableSettingService.isColumnVisible("days")) {
            <td>
              @if (trip.days) {
                {{ trip.days }}
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (tableSettingService.isColumnVisible("travellers")) {
            <td>
              @if (trip.travellers) {
                {{ trip.travellers }}
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          @if (tableSettingService.isColumnVisible("totalImpact")) {
            <td class="!py-2">
              <div class="flex min-h-[40px] flex-col justify-center">
                @if (trip.totalImpact) {
                  <span>{{ trip.totalImpact | formatCO2e }}</span>
                  @if (trip.impactPerTraveller) {
                    <span class="text-sm leading-tight text-greyscale-500"
                      >({{ trip.impactPerTraveller | formatCO2e }}/pers.)</span
                    >
                  }
                } @else {
                  <span class="text-gray-500">--</span>
                }
              </div>
            </td>
          }
          @if (tableSettingService.isColumnVisible("ecoScore")) {
            <td>
              @if (trip.ecoScore) {
                <app-ecoscore [ecoScore]="trip.ecoScore" />
              } @else {
                <span class="text-gray-500">--</span>
              }
            </td>
          }
          <td (click)="$event.stopPropagation()" class="!py-0">
            <div
              class="opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100 [&_button]:!h-8 [&_button]:!w-8 [&_button]:!p-0"
            >
              <app-actions [options]="travelBoardService.getActions(trip)" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            [attr.colspan]="tableSettingService.emptyColspan()"
            class="!py-16"
          >
            <div class="flex flex-col items-center justify-center gap-4">
              <div
                class="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100"
              >
                <lucide-icon name="search-x" class="h-8 w-8 text-primary-500" />
              </div>
              <div class="flex flex-col items-center gap-1 text-center">
                <span class="text-lg font-semibold text-gray-800">{{
                  "travelBoards.noFilterResults" | transloco
                }}</span>
                <span class="text-gray-500">{{
                  "travelBoards.noFilterResultsExplanation" | transloco
                }}</span>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
